<!-- the list itself lives in the parent route (`pages/people.vue`), so that it
     stays mounted while `pages/people/[slug].vue` opens on top of it -->
<template>
  <div />
</template>
